import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Autocomplete, Chip, TextField } from "@mui/material";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";

export const CompaniesStations = ({
  companies = false,
  multi = false,
  multiStations = false,
  enableSelectAll = false,
  state,
  dispatchAction = () => null,
  gridWidth,
  limitTags,
}) => {
  const { companiesList } = useSelector(({ companies }) => companies);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      companies &&
      dispatchAction &&
      !state?.company &&
      companiesList.length === 1 &&
      !enableSelectAll
    ) {
      dispatch(dispatchAction("company", companiesList[0]));
    }
  }, []);

  useEffect(() => {
    if (!enableSelectAll && state?.company === null) {
      dispatch(dispatchAction("station", multiStations ? [] : null));
    }
  }, [state?.company]);

  // Modo con select all: multi empresa
  if (enableSelectAll) {
    const companyOptions = companiesList.map((c) => ({
      ...c,
      value: c.id,
      label: c.label || c.name,
    }));

    const handleCompanyChange = ({ company }) => {
      dispatch(dispatchAction("company", company || []));
      // Filtrar estaciones seleccionadas que ya no pertenecen a las empresas.
      // Sin empresas seleccionadas todas las plantas son válidas.
      const currentStations = state?.station || [];
      if (currentStations.length && company?.length) {
        const validStationIds = new Set();
        company.forEach((comp) => {
          if (comp?.stations) {
            comp.stations.forEach((st) => validStationIds.add(st.id));
          }
        });
        const filtered = currentStations.filter((st) =>
          validStationIds.has(st.value)
        );
        dispatch(dispatchAction("station", filtered));
      }
    };

    return (
      <Grid item xs={12} sm={3}>
        <AutocompleteComponent
          label="Empresas"
          name="company"
          value={state?.company || []}
          handleValues={handleCompanyChange}
          options={companyOptions}
          multiple
          enableSelectAll
          allLabel="Todas las empresas"
          limitTags={limitTags || 2}
          size="small"
          fullWidth
          variant="outlined"
        />
      </Grid>
    );
  }

  // Modo original: single company + stations de esa company
  return (
    <>
      <Grid item xs={12} sm={3}>
        <Autocomplete
          id="combo-box-demo"
          options={companiesList}
          value={multi ? state?.company || [] : state?.company || null}
          getOptionLabel={(option) => option?.label || ""}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                variant="outlined"
                label={option.label}
                {...getTagProps({ index })}
                style={{
                  borderRadius: 4,
                }}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Empresa"
              variant="outlined"
              size="small"
            />
          )}
          fullWidth
          onChange={(_e, v) => dispatch(dispatchAction("company", v))}
          noOptionsText="No se encuentra la Empresa"
        />
      </Grid>
      <Grid item xs={12} sm={3} md={gridWidth}>
        <Autocomplete
          id="combo-box-demo"
          filterSelectedOptions
          options={state?.company?.stations || []}
          value={state?.station || null}
          getOptionLabel={(option) => option?.label || ""}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                variant="outlined"
                label={option.label}
                {...getTagProps({ index })}
                style={{
                  borderRadius: 4,
                }}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Planta"
              variant="outlined"
              size="small"
            />
          )}
          fullWidth
          onChange={(_e, v) => dispatch(dispatchAction("station", v))}
          noOptionsText="No se encuentra la planta"
          limitTags={limitTags}
          multiple={multiStations}
        />
      </Grid>
    </>
  );
};
